import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, useEventCallback } from '@mui/material';
import { memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import CivilStatusForm from './form';
import { AccordionTitle } from 'shell/components/shared/accordion-title';
import { AccordionCivilStatus } from 'shell/view-models/accordion-civil-status';
import { CancelCivilUnionFormVM } from 'mutation/view-models/cancel-civil-union';
import { AccordionCivilStatusMutation } from 'mutation/view-models/civil-status';

interface CivilStatusProps {
  disabled?: boolean;
  isEditMode?: boolean;
}

const CivilStatusComponent = ({ disabled, isEditMode }: CivilStatusProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  const formContext = useFormikContext<CancelCivilUnionFormVM>();

  const onFieldCivilStatusChange = useEventCallback(
    (
      key: keyof AccordionCivilStatusMutation,
      value: AccordionCivilStatusMutation[keyof AccordionCivilStatusMutation]
    ) => {
      formContext.setFieldValue('civilStatus', {
        ...(formContext.values.civilStatus || {}),
        [key]: value,
      });
    }
  );

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-civil-status-content"
        id="panel-person-civil-status-header"
        expandIcon={<ExpandMore />}
      >
        <AccordionTitle isEditMode={isEditMode}>Stato Civile</AccordionTitle>
      </AccordionSummary>
      <AccordionDetails>
        <CivilStatusForm
          disabled={disabled}
          values={formContext.values.civilStatus}
          onChange={onFieldCivilStatusChange}
          isEditMode={isEditMode}
          errors={formContext.errors.civilStatus as FormikErrors<AccordionCivilStatus>}
          touched={
            formContext.touched.civilStatus as unknown as FormikTouched<AccordionCivilStatus>
          }
        />
      </AccordionDetails>
    </Accordion>
  );
};

CivilStatusComponent.displayName = 'Accordion civil status component';

const CivilStatus = memo(CivilStatusComponent);

export default CivilStatus;
